import styled from 'styled-components'

export const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
  padding: 4rem 0;
`

export const ErrorTitle = styled.h2`
  color: ${props => props.theme.colors.color2d3139};
  font-family: 'Inter';
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
`

export const ErrorDescription = styled.p`
  color: ${props => props.theme.colors.color5a6a7e};
  text-align: center;
  font-family: 'Inter';
  font-size: 16px;
  white-space: pre-line;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`
